import { createFileRoute } from "@tanstack/react-router";

import ReconciliationPage from "@/features/dashboard/pages/reconciliation";

export const Route = createFileRoute("/(app)/dashboard/reconciliation")({
  component: () => <ReconciliationPage />,
});
